import { useMemo } from "react";
import { getUserTimezone } from "@/utils/timezoneUtils";

interface ConversationDateHeaderProps {
  date: string;
}

export default function ConversationDateHeader({ date }: ConversationDateHeaderProps) {
  const formattedDate = useMemo(() => {
    const timezone = getUserTimezone();
    const messageDate = new Date(date);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    // Convert to date-only strings in user's timezone for comparison
    const messageDateStr = messageDate.toLocaleDateString(undefined, { timeZone: timezone });
    const todayStr = today.toLocaleDateString(undefined, { timeZone: timezone });
    const yesterdayStr = yesterday.toLocaleDateString(undefined, { timeZone: timezone });

    if (messageDateStr === todayStr) {
      return "Today";
    } else if (messageDateStr === yesterdayStr) {
      return "Yesterday";
    } else {
      // Show day of week and date for older messages
      return messageDate.toLocaleDateString(undefined, { 
        timeZone: timezone,
        weekday: 'long', 
        month: 'short', 
        day: 'numeric',
        year: messageDate.getFullYear() !== today.getFullYear() ? 'numeric' : undefined
      });
    }
  }, [date]);

  return (
    <div className="flex justify-center my-4">
      <div className="bg-muted/50 px-3 py-1 rounded-full">
        <span className="text-xs text-muted-foreground font-medium">
          {formattedDate}
        </span>
      </div>
    </div>
  );
}